<template>
  <section class="smart-meter">
    <StepWizard
      v-model="currentStepNumber"
      :steps="steps"
      show-progress-bar
      @returned="$router.push({ path: '/' })"
      @completed="confirm"
    />
  </section>
</template>

<script>
import StepWizard from "@soenergy/frontend-library/src/components/StepWizard.vue"
import ErrorReporter from "@soenergy/frontend-library/src/services/ErrorReporter"

export default {
  components: {
    StepWizard,
  },
  data() {
    return {
      currentStepNumber: null,
      bookingStarted: false,
    }
  },
  computed: {
    steps() {
      const initialStep = {
        routeName: `${this.appointmentType}-choose-appointment`,
      }

      const registerFlowStep = {
        routeName: `${this.appointmentType}-register-interest`,
      }

      const bookingFlowSteps = [
        {
          routeName: `${this.appointmentType}-installation-essentials`,
        },
        {
          routeName: `${this.appointmentType}-contact-details`,
        },
        {
          routeName: `${this.appointmentType}-meter-access`,
        },
        {
          routeName: `${this.appointmentType}-engineer-access`,
        },
        {
          routeName: `${this.appointmentType}-confirm`,
        },
      ]

      return this.$store.state.isRegisterInterestFlow
        ? [initialStep, registerFlowStep]
        : [initialStep, ...bookingFlowSteps]
    },
    appointmentType() {
      return this.$route.meta.appointmentType
    },
  },
  methods: {
    async confirm() {
      if (this.$store.state.isRegisterInterestFlow) {
        this.$router.push({ path: "/interest-confirmed" })
        return
      }

      if (this.$store.state.submitStatus === "PENDING") {
        return
      }

      try {
        await this.$store.dispatch("bookAppointment", this.appointmentType)
        if (this.$store.state.submitStatus === "SUCCESS") {
          this.$router.push({ path: "/booking-confirmed" })
        }
      } catch (error) {
        if (this.$store.state.submitError?.includes("appointment already")) {
          this.$router.push({ path: "/appointment-details" })
          return
        }
        ErrorReporter.report(error)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.smart-meter {
  align-items: center;
  margin: auto;
  padding: 0 $space-4;

  @include md {
    width: $width-5;
  }
}
::v-deep .step-wizard__back-link {
  margin-bottom: $space-4;

  @include md {
    margin-bottom: $space-8;
  }
}
</style>
